<h4 class="breadcrumb-wrapper m-0">
    <span class="text-muted fw-light">
        {{'Administration' | translate}}
    </span>
       / {{'ApiDocumentation' | translate}}
</h4>

<div class="container-xxl flex-grow-1 container-p  ">
    <div class="row">
        <div class="col-lg-3 col-12">
            <div class="card card-fix larg-size-api">
                <div class="card-header-title">
                    <h6>{{'ApiServiceList' | translate}}</h6>
                    <hr>
                </div>
                <div class="serach-box p-1">
                    <input type="text" class="form-control" (keyup)="searchApi()" [(ngModel)]="searchedItem"
                        placeholder="{{ 'public.search' | translate }} ...">
                </div>
                <div id="tree-view" class="accordion tree-view">
                    <div *ngFor="let folder of data;let i=index" class="accordion-item">
                        <h2 class="accordion-header" [id]="'heading'+i">
                            <button type="button" class="accordion-button tree-view-parent-button collapsed"
                                data-bs-toggle="collapse" aria-expanded="true" [attr.data-bs-target]="'#accordion'+i"
                                [attr.aria-controls]="'accordion'+i">
                                <i class='bx mx-1'></i>
                                {{ folder.name }}
                            </button>
                        </h2>
                        <div [id]="'accordion'+i" class="accordion-collapse tree-view-body collapse"
                            data-bs-parent="#tree-view">
                            <ul class="tree-view-inside-ul">
                                <li class="tree-view-inside-li" *ngFor="let request of folder.item;let j=index">
                                    <button class="tree-view-inside-button" type="button"
                                        [ngClass]="selectedItem==j&&selectedGroupItem==i ? 'selected-item-api' : null"
                                        (click)="selectApi(request,j,i)">
                                        <span class="api-type get-method mx-1" [ngClass]="request.request.method">
                                            {{ request.request.method }}
                                        </span>
                                        <span>
                                            {{ request.name }}
                                        </span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-lg-9 col-12 pt-lg-0 pt-2 " *ngIf="selectApiItem">
            <div class="card card-fix">
                <div *ngIf="successMessage" class="alert alert-solid-success alert-dismissible fade show" role="alert">
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
                        (click)="successMessage=false"></button>
                    <strong>
                        {{'CopyToClipboardCompeleted' | translate}}
                    </strong>
                </div>
                <div class="row api-header m-0 menu-icon-fix">
                    <div class="col-6">
                        <h6>Api Details</h6>
                    </div>
                    <div class="col-6 d-flex justify-content-end mt-1">
                        <button class="btn btn-icon btn-primary me-1 small-size-api" (click)="openMenuModal(addcontent)">
                            <i class="fas fa-bars"></i>
                        </button>
                        <button type="button" class="btn btn-icon btn-outline-primary me-1" placement="bottom"
                            ngbTooltip="Curl" (click)="openModal(curlModal)">
                            <span class="tf-icons fa-solid fa-code"></span>
                        </button>
                        <button type="button" class="btn btn-icon btn-outline-primary me-1" placement="bottom"
                            ngbTooltip="field information" (click)="openModal(informationModal)">
                            <span class="tf-icons fa-solid fa-info"></span>
                        </button>
                    </div>
                </div>
                <div class="url-box m-2 mt-0">
                    <span class="api-type get-method mx-1" [ngClass]="selectApiItem.method">
                        {{ selectApiItem.method }}
                    </span>
                    <input class="px-2" type="text" disabled [(ngModel)]="selectApiItem.url">
                    <button type="button" (click)="copyToclipboard(selectApiItem.url)">
                        <i class="bx bx-copy"></i>
                        {{'Copy' | translate}}
                    </button>
                </div>
                <div class="text-box-api request-box m-2 mt-0">
                    <pre>{{ selectApiItem.request | jsonData }}</pre>
                    <button type="button" (click)="copyToclipboard(selectApiItem.requestString)">
                        <i class="bx bx-copy"></i>
                        {{'Copy' | translate}}
                    </button>
                </div>
                <div class="response-box m-2 mt-0">
                    <div class="text-box-api response-error">
                        <span class="p-1">
                            {{'Error' | translate}}
                        </span>
                        <pre>{{ selectApiItem.responseError | jsonData }}</pre>
                        <button type="button" (click)="copyToclipboard(selectApiItem.responseSuccessString)">
                            <i class="bx bx-copy"></i>
                            {{'Copy' | translate}}
                        </button>
                    </div>
                    <div class="text-box-api response-success">
                        <span class="p-1">
                            {{'Success' | translate}}
                        </span>
                        <pre>{{ selectApiItem.responseSuccess | jsonData }}</pre>
                        <button type="button" (click)="copyToclipboard(selectApiItem.responseErrorString)">
                            <i class="bx bx-copy"></i>
                            {{'Copy' | translate}}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<ng-template #curlModal let-modal class="modal modal-top fade">
    <form class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title secondary-font" id="modalTopTitle">
                Code snippet
            </h5>
            <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="nav-align-top">
                <ul class="nav nav-tabs nav-fill" role="tablist">
                    <li class="nav-item">
                        <button type="button" class="nav-link active" role="tab" data-bs-toggle="tab"
                            data-bs-target="#navs-justified-curl" aria-controls="navs-justified-curl"
                            aria-selected="true">
                            Curl
                        </button>
                    </li>
                    <li class="nav-item">
                        <button type="button" class="nav-link" role="tab" data-bs-toggle="tab"
                            data-bs-target="#navs-justified-csharp" aria-controls="navs-justified-csharp"
                            aria-selected="false">
                            C#
                        </button>
                    </li>
                    <li class="nav-item">
                        <button type="button" class="nav-link" role="tab" data-bs-toggle="tab"
                            data-bs-target="#navs-justified-java" aria-controls="navs-justified-java"
                            aria-selected="false">
                            Java Unirest
                        </button>
                    </li>
                    <li class="nav-item">
                        <button type="button" class="nav-link" role="tab" data-bs-toggle="tab"
                            data-bs-target="#navs-justified-jquery" aria-controls="navs-justified-jquery"
                            aria-selected="false">
                            Javascript jQuery
                        </button>
                    </li>
                    <li class="nav-item">
                        <button type="button" class="nav-link" role="tab" data-bs-toggle="tab"
                            data-bs-target="#navs-justified-kotlin" aria-controls="navs-justified-kotlin"
                            aria-selected="false">
                            Kotlin
                        </button>
                    </li>
                    <li class="nav-item">
                        <button type="button" class="nav-link" role="tab" data-bs-toggle="tab"
                            data-bs-target="#navs-justified-python" aria-controls="navs-justified-python"
                            aria-selected="false">
                            Python
                        </button>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="navs-justified-curl" role="tabpanel">
                        <div class="added-cards">
                            <div class="cardMaster ">
                                <div class="curl-box px-3 py-2 pt-4">
                                    <div class="curl-item" *ngFor="let item of selectApiItem.curl;let i=index;">
                                        <span class="me-3">{{ i + 1 }}</span>
                                        <pre>{{ item }}</pre>
                                    </div>
                                    <button class="code-snnipet-copy" type="button" (click)="codeAlertBox=true;">
                                        <i class="fa-regular fa-copy"></i>
                                    </button>
                                    <div class="alert-box" [ngClass]="codeAlertBox==false? 'aler-hide' : null"
                                        (click)="codeAlertBox=false;">
                                        <h3>Copy To Clipboard..</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="navs-justified-csharp" role="tabpanel">
                        <div class="added-cards">
                            <div class="cardMaster ">
                                <div class="curl-box px-3 py-2 pt-4">
                                    <div class="curl-item" *ngFor="let item of selectApiItem.csharp;let i=index;">
                                        <span class="me-3">{{ i + 1 }}</span>
                                        <pre>{{ item }}</pre>
                                    </div>
                                    <button class="code-snnipet-copy" type="button" (click)="codeAlertBox=true;">
                                        <i class="fa-regular fa-copy"></i>
                                    </button>
                                    <div class="alert-box" [ngClass]="codeAlertBox==false? 'aler-hide' : null"
                                        (click)="codeAlertBox=false;">
                                        <h3>Copy To Clipboard..</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="navs-justified-java" role="tabpanel">
                        <div class="added-cards">
                            <div class="cardMaster ">
                                <div class="curl-box px-3 py-2 pt-4">
                                    <div class="curl-item" *ngFor="let item of selectApiItem.java;let i=index;">
                                        <span class="me-3">{{ i + 1 }}</span>
                                        <pre>{{ item }}</pre>
                                    </div>
                                    <button class="code-snnipet-copy" type="button" (click)="codeAlertBox=true;">
                                        <i class="fa-regular fa-copy"></i>
                                    </button>
                                    <div class="alert-box" [ngClass]="codeAlertBox==false? 'aler-hide' : null"
                                        (click)="codeAlertBox=false;">
                                        <h3>Copy To Clipboard..</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="navs-justified-jquery" role="tabpanel">
                        <div class="added-cards">
                            <div class="cardMaster ">
                                <div class="curl-box px-3 py-2 pt-4">
                                    <div class="curl-item" *ngFor="let item of selectApiItem.jQuery;let i=index;">
                                        <span class="me-3">{{ i + 1 }}</span>
                                        <pre>{{ item }}</pre>
                                    </div>
                                    <button class="code-snnipet-copy" type="button" (click)="codeAlertBox=true;">
                                        <i class="fa-regular fa-copy"></i>
                                    </button>
                                    <div class="alert-box" [ngClass]="codeAlertBox==false? 'aler-hide' : null"
                                        (click)="codeAlertBox=false;">
                                        <h3>Copy To Clipboard..</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="navs-justified-kotlin" role="tabpanel">
                        <div class="added-cards">
                            <div class="cardMaster ">
                                <div class="curl-box px-3 py-2 pt-4">
                                    <div class="curl-item" *ngFor="let item of selectApiItem.kotlin;let i=index;">
                                        <span class="me-3">{{ i + 1 }}</span>
                                        <pre>{{ item }}</pre>
                                    </div>
                                    <button class="code-snnipet-copy" type="button" (click)="codeAlertBox=true;">
                                        <i class="fa-regular fa-copy"></i>
                                    </button>
                                    <div class="alert-box" [ngClass]="codeAlertBox==false? 'aler-hide' : null"
                                        (click)="codeAlertBox=false;">
                                        <h3>Copy To Clipboard..</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="navs-justified-python" role="tabpanel">
                        <div class="added-cards">
                            <div class="cardMaster ">
                                <div class="curl-box px-3 py-2 pt-4">
                                    <div class="curl-item" *ngFor="let item of selectApiItem.Python;let i=index;">
                                        <span class="me-3">{{ i + 1 }}</span>
                                        <pre>{{ item }}</pre>
                                    </div>
                                    <button class="code-snnipet-copy" type="button" (click)="codeAlertBox=true;">
                                        <i class="fa-regular fa-copy"></i>
                                    </button>
                                    <div class="alert-box" [ngClass]="codeAlertBox==false? 'aler-hide' : null"
                                        (click)="codeAlertBox=false;">
                                        <h3>Copy To Clipboard..</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </form>
</ng-template>


<ng-template #informationModal let-modal class="modal modal-top fade">
    <form class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title secondary-font" id="modalTopTitle">
                Field Information
            </h5>
            <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="field-information-div">
                <div class="table-fields table-responsive">
                    <table class="table datatables-ajax">
                        <thead class="table-header-dark-light">
                            <tr class="table-light">
                                <th class="side-column  px-1" scope="col">
                                    #
                                </th>
                                <th scope="col">
                                    name
                                </th>
                                <th scope="col">
                                    type
                                </th>
                                <th scope="col">
                                    isMandatory
                                </th>
                                <th scope="col">
                                    pattern
                                </th>
                                <th scope="col">
                                    editable
                                </th>
                            </tr>
                        </thead>
                        <tbody class="table-body-dark-light" *ngIf="selectApiItem.fileds.length>0;else noData">
                            <tr *ngFor="let item of selectApiItem.fileds;let i=index;">
                                <td class="side-column  px-1" scop="row">{{ i+1 }}</td>
                                <td>
                                    {{ item.name }}
                                </td>
                                <td>
                                    {{ item.type }}
                                </td>
                                <td>
                                    <i class="fa-solid fa-check"
                                        [ngClass]="item.isMandatory? 'fa-check' : 'fa-xmark'"></i>
                                </td>
                                <td>
                                    {{ item.pattern }}
                                </td>
                                <td>
                                    <i class="fa-solid fa-check" [ngClass]="item.editable? 'fa-check' : 'fa-xmark'"></i>
                                </td>

                            </tr>
                        </tbody>
                        <ng-template #noData>
                            <tbody>
                                <tr>
                                    <td [attr.colspan]="6" colspan="" scop="col">
                                        &nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </ng-template>

                    </table>
                    <div class="no-data-row" *ngIf="selectApiItem.fileds.length==0">
                        <p>{{'NoData' | translate}}</p>
                    </div>
                    <app-loading-panel *ngIf="loading"></app-loading-panel>
                </div>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #addcontent let-offcanvas>
    <div class="offcanvas-header border-bottom">
        <h6 id="offcanvasAddUserLabel" class="offcanvas-title">Api Service List</h6>
        <button type="button" class="btn-close text-reset" (click)="offcanvas.dismiss('Cross click')"
            aria-label="Close"></button>
    </div>
    <div class="offcanvas-body mx-0 flex-grow-0">
        <div id="tree-view" class="accordion tree-view">
            <div *ngFor="let folder of data;let i=index" class="accordion-item">
                <h2 class="accordion-header" [id]="'heading'+i">
                    <button type="button" class="accordion-button tree-view-parent-button collapsed"
                        data-bs-toggle="collapse" aria-expanded="true" [attr.data-bs-target]="'#accordion'+i"
                        [attr.aria-controls]="'accordion'+i">
                        <i class='bx mx-1'></i>
                        {{ folder.name }}
                    </button>
                </h2>

                <div [id]="'accordion'+i" class="accordion-collapse tree-view-body collapse"
                    data-bs-parent="#tree-view">
                    <ul class="tree-view-inside-ul">
                        <li class="tree-view-inside-li" *ngFor="let request of folder.item;let j=index">
                            <button class="tree-view-inside-button" type="button"
                                [ngClass]="selectedItem==j&&selectedGroupItem==i ? 'selected-item-api' : null"
                                (click)="selectApi(request,j,i)">
                                <span class="api-type get-method mx-1" [ngClass]="request.request.method">
                                    {{ request.request.method }}
                                </span>
                                <span>
                                    {{ request.name }}
                                </span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</ng-template>